 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		18: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"8fb5dbc09e506c70258e16b6e48c6a5b1195e539","2":"5ba45f63acdc5aca112f26883a7e051cb76ebc81","3":"1bc699b90fe94e7c2de1031992cde3a4b2a67425","4":"953529affb241643b097b7a172547e8e588c10b7","5":"framework","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"068de6f06151eeb4d545e13865e6b6ef0514e03e","11":"fa1a4ddbc755172e76f8af1687f1491052abe762","12":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","13":"d777fbe096206c5505e8caa70ad0bf9957027abe","14":"b9b041f39dc3568dd313b944196020ea562c7d57","15":"bc62dab504a71ef8c5d240a105694d09627f06f3","16":"component---src-pages-integration-builder-sections-code-tsx","17":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","19":"11e8d57d","21":"4b80be75","22":"5cf42e9e","23":"962beaf7","25":"component---src-pages-404-js","26":"component---src-pages-banner-js","27":"component---src-pages-build-better-js","28":"component---src-pages-classic-home-js","29":"component---src-pages-docs-template-js","30":"component---src-pages-integration-builder-index-tsx","31":"component---src-pages-integration-builder-sections-build-tsx","32":"component---src-pages-integration-builder-sections-card-generator-tsx","33":"component---src-pages-integration-builder-sections-configure-tsx","34":"component---src-pages-integration-builder-sections-demo-tsx","35":"component---src-pages-integration-builder-sections-help-modal-tsx","36":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","37":"component---src-pages-integration-builder-sections-preview-tsx","38":"component---src-pages-integration-builder-sections-take-live-tsx","39":"component---src-pages-internal-js","40":"component---src-pages-signup-js","41":"component---src-pages-signupauto-js","42":"component---src-pages-support-js","43":"component---src-pages-thankyou-js","44":"component---src-pages-unsubscribe-js","45":"component---src-pages-video-collection-tsx","46":"component---src-pages-video-home-tsx","47":"component---src-pages-video-watch-tsx","48":"component---src-templates-template-layout-js","49":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"6ff23ad662b7401ec98d","2":"4b3adaada3c3d31f262b","3":"16d43533e3f76538641d","4":"6981740046a7ddfbf9ba","5":"0747ebf1c29a652cf4df","6":"1e4e97e05ea112046acb","7":"41ab77f1ceccb78d9a26","8":"7d96833ee86666c8fa60","9":"118ec6a6022145e692c1","10":"580245f2e3c124fd2621","11":"f967fad61dbae974aee2","12":"0a67c823eacb4b56edf3","13":"fc97b1cf914edc1ae8b4","14":"42b55d7ec47469d930c0","15":"8a03fd149ed786d0b97a","16":"1b09d1abbea4054ff1fe","17":"ad3503cf2d4c863ea336","19":"354491bd2b89136083d7","21":"522ec62bf5a41b889981","22":"87441d3ed2834d03e6ee","23":"3468fda8fe10f42b6a98","25":"8c27ea542b3b36d0e994","26":"1809c4a561e8094e3458","27":"e19c60a2fdef0c5d6eb6","28":"a6753f15f62c0c25c60b","29":"62c67427764cea6c2358","30":"293cdd3d489c61aea995","31":"86521b622fe04de7e205","32":"3427d9c7141fbf4db1bb","33":"66ac4f01a11dfd86cc99","34":"a9683bee78fc578e7e58","35":"38f6add9d451bad1099f","36":"a4f6505006cc168a37ae","37":"46d54595992db7ea3a6a","38":"3fab698d123924f21228","39":"19fed5f1db7ddcf7d7ee","40":"bbd235b36bcf9b017048","41":"d4af529a8c5492c8de7c","42":"56e21fa939a4df216d50","43":"ea508bf50cd13cfe500f","44":"54c4e5bbfce4a3be9bba","45":"1ddf3276d873bb25d6a3","46":"a8cd1b8c30ecabc9f323","47":"58b51623744f4b03a2e6","48":"9a639acbac1cac546c37","49":"210a2cccbd183c31029d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"8fb5dbc09e506c70258e16b6e48c6a5b1195e539","2":"5ba45f63acdc5aca112f26883a7e051cb76ebc81","3":"1bc699b90fe94e7c2de1031992cde3a4b2a67425","4":"953529affb241643b097b7a172547e8e588c10b7","5":"framework","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"068de6f06151eeb4d545e13865e6b6ef0514e03e","11":"fa1a4ddbc755172e76f8af1687f1491052abe762","12":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","13":"d777fbe096206c5505e8caa70ad0bf9957027abe","14":"b9b041f39dc3568dd313b944196020ea562c7d57","15":"bc62dab504a71ef8c5d240a105694d09627f06f3","16":"component---src-pages-integration-builder-sections-code-tsx","17":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","19":"11e8d57d","21":"4b80be75","22":"5cf42e9e","23":"962beaf7","25":"component---src-pages-404-js","26":"component---src-pages-banner-js","27":"component---src-pages-build-better-js","28":"component---src-pages-classic-home-js","29":"component---src-pages-docs-template-js","30":"component---src-pages-integration-builder-index-tsx","31":"component---src-pages-integration-builder-sections-build-tsx","32":"component---src-pages-integration-builder-sections-card-generator-tsx","33":"component---src-pages-integration-builder-sections-configure-tsx","34":"component---src-pages-integration-builder-sections-demo-tsx","35":"component---src-pages-integration-builder-sections-help-modal-tsx","36":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","37":"component---src-pages-integration-builder-sections-preview-tsx","38":"component---src-pages-integration-builder-sections-take-live-tsx","39":"component---src-pages-internal-js","40":"component---src-pages-signup-js","41":"component---src-pages-signupauto-js","42":"component---src-pages-support-js","43":"component---src-pages-thankyou-js","44":"component---src-pages-unsubscribe-js","45":"component---src-pages-video-collection-tsx","46":"component---src-pages-video-home-tsx","47":"component---src-pages-video-watch-tsx","48":"component---src-templates-template-layout-js","49":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"d8241d1612be55b93052","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/migrationv1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
